
import { testimonials as mockTestimonials } from '../../../mocks/homepage';

export default function TestimonialsSection() {
  const testimonials = Array.isArray(mockTestimonials) ? mockTestimonials : [];

  return (
    <section className="py-24 bg-carbon-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-xs font-bold uppercase tracking-widest text-neon mb-3 block">
            Testimonials
          </span>
          <h2 className="text-4xl font-bold text-white tracking-tight">
            What Our Users Say
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/5">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-carbon-950 p-8 hover:bg-carbon-900 transition-all duration-300"
            >
              <div className="flex items-center gap-0.5 mb-5">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i
                    key={star}
                    className="ri-star-fill text-neon text-sm"
                  ></i>
                ))}
              </div>

              <p className="text-sm text-white/50 leading-relaxed mb-6">
                &ldquo;{t.text}&rdquo;
              </p>

              <div className="flex items-center gap-3 pt-5 border-t border-white/5">
                <div className="w-10 h-10 bg-neon/10 border border-neon/20 flex items-center justify-center text-neon text-xs font-bold">
                  {t.avatar}
                </div>
                <div>
                  <div className="text-sm font-bold text-white">{t.name}</div>
                  <div className="text-xs text-white/30">{t.role}</div>
                </div>
              </div>

              <div className="mt-4 px-3 py-1.5 bg-white/5 border border-white/5 inline-flex items-center gap-1.5">
                <i className="ri-heart-fill text-neon text-xs"></i>
                <span className="text-xs text-white/40">
                  Recommends{' '}
                  <strong className="text-white/60">{t.product}</strong>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
